import React, { useEffect } from 'react';
import './About.css';
import aboutimg from '../src/image/whoweare.jpg';
import Footer from './Footer';
import Header from './Header';
import 'aos/dist/aos.css';
import AOS from 'aos';
import Breadcrumbs from './Products/Breadcrumbs';
function About() {
    useEffect(() => {
        AOS.init({
            duration: 900,
            easing: 'ease-out-cubic',
            once: true,
        });
    }, []);

    const isHome = window.location.pathname === '/';

    const features = [
        "We approach each project with a holistic perspective, considering not only the visual elements but also the functionality and overall experience of the space.",
        "Your dreams and preferences are at the center of our design process.",
        "We work closely with our clients to understand their vision and bring it to fruition.",
        "It's the small details that make a design truly exceptional.",
        "We embrace innovation and modern trends."
    ];

    return (
        <div className='container-fluid p-0'>
            {!isHome && <div className='sticky-top'><Header /></div>}
 
            <section id="about-card">
                
                    <header className="about-section-header" data-aos="fade-up">{window.location.pathname !== "/" && <Breadcrumbs />}
                        <h2 className="about-main-heading">Who We Are</h2>
                        <p className="about-main-description">
                            Welcome to Indec, where creativity meets functionality,
                            and every space tells a unique story. We are not just Interiors;
                            we are storytellers, transforming environments into captivating narratives
                            that reflect the essence of those who inhabit them.
                        </p>
                    </header>
                


                {/* Two-column layout below */}
                <div className="row mt-4">
                    <div className="col-lg-6 content" data-aos="fade-right">
                        <ul>
                            {features.map((item, index) => (
                                <li key={index} data-aos="fade-up" data-aos-delay={index * 150}>
                                    <i className="bi bi-check-circle"></i>
                                    {item}
                                </li>
                            ))}
                        </ul>
                    </div>

                    <div className="col-lg-6 about-img-wrapper" data-aos="fade-left">
                        <div className="about-img-card">
                            <img src={aboutimg} alt="Who we are" />
                        </div>
                    </div>
                </div>
            </section>

            {!isHome && <Footer />}
        </div>
    );
}

export default About;
